export const TicketsSidebar = {
  extends: 'AppSidebar',
  tag: 'nav',
  attr: { 'aria-label': 'Tickets navigation' },

  // No PeopleSection on tickets
  PeopleSection: null,

  Top: null,

  Middle: {
    overflow: 'auto',
    flex: '1',

    // ── Tickets ──
    TicketsGroup: {
      extends: 'TicketsSidebarGroup',
      label: 'TICKETS',
      List: {
        flow: 'y',
        gap: 'V',
        childExtends: 'TicketsSidebarItem',
        children: [
          { href: '/tickets', label: 'My view', icon: 'user' },
          { href: '/tickets/general', label: 'General', icon: 'state' },
          { href: '/tickets/feed', label: 'Feed', icon: 'clock' },
          { href: '/tickets/canvas', label: 'Canvas', icon: 'magicstar' },
          { href: '/tickets/epics', label: 'Epics', icon: 'magicstar' },
          { href: '/tickets/stories', label: 'Stories', icon: 'star' },
          { href: '/tickets/board', label: 'Board', icon: 'borderRadius' },
          { href: '/tickets/status', label: 'Status', icon: 'check' }
        ]
      }
    },

    // ── Requests (sales + feedback) ──
    RequestsGroup: {
      extends: 'TicketsSidebarGroup',
      label: 'REQUESTS',
      List: {
        flow: 'y',
        gap: 'V',
        childExtends: 'TicketsSidebarItem',
        children: [
          {
            href: '/tickets/requests',
            label: 'Customer requests',
            icon: 'chat'
          },
          {
            href: '/tickets/requests/inbound',
            label: 'Inbound',
            icon: 'arrowDown'
          },
          {
            href: '/tickets/requests/outbound',
            label: 'Outbound',
            icon: 'arrowUp'
          },
        ]
      }
    },

    // ── Resolutions (PR-like) ──
    ResolutionsGroup: {
      extends: 'TicketsSidebarGroup',
      label: 'RESOLUTIONS',
      List: {
        flow: 'y',
        gap: 'V',
        childExtends: 'TicketsSidebarItem',
        children: [
          { href: '/tickets/resolutions', label: 'Resolutions', icon: 'check' },
          {
            href: '/tickets/resolutions/improvements',
            label: 'Improvement requests',
            icon: 'magicstar'
          },
          {
            href: '/tickets/resolutions/edit-requests',
            label: 'Edit requests',
            icon: 'edit'
          },
          {
            href: '/tickets/requests/audit',
            label: 'Audit / Reports',
            icon: 'document'
          }
        ]
      }
    }
  }
}

// ── Sidebar item — extends SidebarRow with route-based active state ──

export const TicketsSidebarItem = {
  extends: 'SidebarRow',
  padding: 'Z A',
  round: 'C',
  fontSize: 'A',
  background: (el, s) =>
    (s.root?.currentPath || s.root?.route || '/') === el.href
      ? 'overlay'
      : 'transparent',
  color: (el, s) =>
    (s.root?.currentPath || s.root?.route || '/') === el.href
      ? 'title'
      : 'subtitle',
  fontWeight: (el, s) =>
    (s.root?.currentPath || s.root?.route || '/') === el.href ? '600' : '500',

  Icon: {
    boxSize: 'A',
    color: (el, s) =>
      (s.root?.currentPath || s.root?.route || '/') === el.parent?.href
        ? 'blue'
        : 'caption'
  },

  onClick: (e, el) => {
    let rootEl = el
    while (rootEl && !rootEl.routes) rootEl = rootEl.parent
    const router = el.context?.utils?.router
    if (router && rootEl)
      router(el.href, rootEl, {}, { pushState: true, scrollToTop: true })
  },

  MoreBtn: {
    items: [
      { label: 'Pin to top', action: 'pin' },
      { label: 'Customize view', action: 'customize-view' }
    ]
  }
}

// ── Sidebar group shell ──

export const TicketsSidebarGroup = {
  flow: 'y',
  gap: 'Z',
  marginBottom: 'A',

  Header: {
    flow: 'x',
    align: 'center left',
    padding: 'V 0',

    CaptionTitle: {
      flex: '1',
      fontSize: 'Y2',
      Text: {
        text: (el) => el.parent?.parent?.parent?.label || ''
      }
    }
  }
}

export const TicketsFilterBtn = {
  tag: 'button',
  type: 'button',
  flow: 'x',
  align: 'center left',
  gap: 'Z1',
  padding: 'Z A',
  round: 'C',
  cursor: 'pointer',
  fontSize: 'A',
  textDecoration: 'none',
  fontWeight: (el, s) =>
    (s.root?.filterAssignee || 'all') === el.value ? '600' : '500',
  background: (el, s) =>
    (s.root?.filterAssignee || 'all') === el.value ? 'overlay' : 'transparent',
  color: (el, s) =>
    (s.root?.filterAssignee || 'all') === el.value ? 'title' : 'subtitle',
  borderWidth: '0',
  ':hover': { background: 'overlay', color: 'title' },
  transition: 'background 120ms ease',
  onClick: (e, el, s) => {
    s.root.update({ filterAssignee: el.value === 'all' ? null : el.value })
    try {
      el.call('reloadTickets')
    } catch (err) {
      console.error(err)
    }
  },
  Icon: {
    icon: (el) => el.parent?.icon || 'state',
    boxSize: 'A'
  },
  Label: { tag: 'span', text: (el) => el.parent?.label || '' }
}
